import { Navigate, Route, Routes } from 'react-router-dom'

import NavigateToError from '@/features/error/pages/NavigateToError'
import { PrequalificationRouteInformation } from '@/features/prequalification/constants'
import EditResourceSetResources from '@/features/prequalification/pages/EditResourceSetResources'
import NewPrequalificationResourceSet from '@/features/prequalification/pages/NewPrequalificationResourceSet'
import PrequalificationResourceSetDetails from '@/features/prequalification/pages/PrequalificationResourceSetDetails'
import PrequalificationsIndex from '@/features/prequalification/pages/PrequalificationsIndex'

export default function PrequalificationRoutes() {
  return (
    <Routes>
      {/* The section is scoped under `/local`; land the bare path on it so old links still work. */}
      <Route element={<Navigate replace to={PrequalificationRouteInformation.INDEX.navigationPath()} />} path="/" />
      <Route element={<PrequalificationsIndex />} path={PrequalificationRouteInformation.INDEX.routePath} />
      <Route
        element={<NewPrequalificationResourceSet />}
        path={PrequalificationRouteInformation.NEW_RESOURCE_SET.routePath}
      />
      <Route element={<EditResourceSetResources />} path={PrequalificationRouteInformation.EDIT_RESOURCES.routePath} />
      <Route
        element={<PrequalificationResourceSetDetails />}
        path={PrequalificationRouteInformation.RESOURCE_SET_DETAILS.routePath}
      />

      <Route element={<NavigateToError statusCode={404} />} path="*" />
    </Routes>
  )
}
